export default __webpack_public_path__ + "static/live-hero-four-left-8dea4bc16321b652cb7ecf20670fcb00.webp";